import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import BlogSingleArea from "./blogSingleArea";
import BlogSingleAreaSidebar from "./blogSingleAreaSidebar";
import Page from "src/components/Page";
import { GetURL } from "../../config";
import axios from "axios";

function BlogSinglePage() {
  const [data, setData] = useState(null);
  const [categoriesList, setCategoriesList] = useState([]);
  const [pastPosts, setPastPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const { slug } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const wordpressApi = "https://apiblog.leon-gallery.com/wp-json/wp/v2/";

        const requestCategories = axios.get(
          `${wordpressApi}categories?_fields=id,count,name,slug&include=3,4,5`
        );

        const requestPost = axios.get(
          `${wordpressApi}posts?slug=${slug}&_embed=wp:featuredmedia,wp:term&_fields=id,date,slug,title,excerpt,content,_links`
        );

        const requestPastPosts = axios.get(
          `${wordpressApi}posts?_embed=wp:featuredmedia,wp:term&_fields=id,date,slug,title,excerpt,_links&orderby=relevance&search=title&order=asc&categories=3,4,5&per_page=2`
        );

        const [resCategories, resPost, resPastPosts] = await axios.all([
          requestCategories,
          requestPost,
          requestPastPosts,
        ]);

        setCategoriesList(resCategories.data);
        setData(resPost.data[0]); // Get the single post from slug
        setPastPosts(resPastPosts.data);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching blog data:", error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, [slug]);

  // Set meta tags (optional)
  useEffect(() => {
    const sendMeta = async () => {
      const metaData = {
        title: "Art Stories & Insights | Leon Gallery Features & Highlights",
        discription:
          "Explore Leon Gallery’s curated art exhibitions in Manila, featuring renowned Filipino artists and historic collections. View current, upcoming, and past shows.",
        lotNo: "",
        canonical: `${GetURL}/stories`,
        url: `${GetURL}stories`,
        imagUrl: `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
      };

      try {
        const res = await fetch(`${GetURL}/meta`, {
          method: "POST",
          body: JSON.stringify(metaData),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });

        const result = await res.json();
        console.log("Meta sent:", result);
      } catch (err) {
        console.error("Meta error:", err);
      }
    };

    sendMeta();
  }, []);

  return (
    <Page>
      <section className="blog-single-area" style={{ marginTop: 50 }}>
        <div className="container">
          {isLoading ? (
            <div className="d-flex justify-content-center">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-xl-8 col-lg-7 col-md-12 col-sm-12">
                <BlogSingleArea data={data} />
              </div>
              <div className="col-xl-4 col-lg-5 col-md-9 col-sm-12">
                <BlogSingleAreaSidebar
                  categoriesList={categoriesList}
                  pastPost={pastPosts}
                />
              </div>
            </div>
          )}
        </div>
      </section>
    </Page>
  );
}

export default BlogSinglePage;
